<div class="apply-job-container">
  <header class="header-bar">
    <div class="header-title">Apply for a Job</div>
    <div class="header-cancel" (click)="showWarningMessage()">Cancel</div>
  </header>

  @if (carrierData) {
    <div class="company-card">
      <div class="company-logo-wrap" [class.company-logo-wrap--placeholder]="!carrierData.companyLogo">
        @if (carrierData.companyLogo) {
          <img class="company-logo" [src]="carrierData.companyLogo" [alt]="(carrierData.dbaName || carrierData.companyName) + ' logo'" />
        } @else {
          <mat-icon class="company-logo-placeholder" aria-hidden="true">business</mat-icon>
        }
      </div>
      <div class="company-info">
        <div class="company-name">{{ carrierData.dbaName || carrierData.companyName }}</div>
        @if (carrierData.dbaName && carrierData.companyName && carrierData.dbaName !== carrierData.companyName) {
          <div class="company-legal-name">{{ carrierData.companyName }}</div>
        }
      </div>
    </div>
  }

  <form class="form-wrapper" [formGroup]="form" (ngSubmit)="onSubmit()">
    <section class="selection-section">
      <div class="section-header">Select the position you are applying for</div>

      <div class="options-list">
        @for (option of positionOptions; track option) {
          <label class="option">
            <input type="radio" [value]="option.key" formControlName="position" (change)="markTouched('position')" />
            <span class="option-label">{{ option.displayName }}</span>
          </label>
        }
        @if (position.invalid && position.touched) {
          <div class="error">{{ getPositionErrorMessage() }}</div>
        }
      </div>
    </section>

    @if (availableRadiusOptions.length) {
      <section class="selection-section">
        <div class="section-header">Select your desired radius of operation</div>
        <div class="options-list">
          @for (radius of availableRadiusOptions; track radius) {
            <label class="option">
              <input type="radio" [value]="radius.key" formControlName="radius" (change)="markTouched('radius')" />
              <span class="option-label">{{ radius.displayName }}</span>
            </label>
          }
          @if (radius.invalid && radius.touched) {
            <div class="error">{{ getRadiusErrorMessage() }}</div>
          }
        </div>
      </section>
    }

    <section class="selection-section">
      <div class="section-header">How did you hear about this job opening?</div>
      <mat-form-field appearance="fill" class="dropdown-field">
        <mat-select
          formControlName="howDidYouHearAboutJob"
          placeholder="Select an option"
          (selectionChange)="markTouched('howDidYouHearAboutJob')"
          panelClass="custom-select-panel"
        >
          @for (option of howDidYouHearOptions; track option) {
            <mat-option [value]="option">
              {{ option }}
            </mat-option>
          }
        </mat-select>
        @if (form.get('howDidYouHearAboutJob')?.invalid && form.get('howDidYouHearAboutJob')?.touched) {
          <mat-error> Please select an option. </mat-error>
        }
      </mat-form-field>

      @if (optionsRequiringDetails.includes(form.get('howDidYouHearAboutJob')?.value)) {
        <div>
          <mat-form-field appearance="fill" class="dropdown-field specify-field">
            <input
              matInput
              formControlName="howDidYouHearAboutJobDescription"
              [placeholder]="
                form.get('howDidYouHearAboutJob')?.value === 'I am an existing employee of this company'
                  ? 'Please specify:'
                  : 'Please specify: *'
              "
            />
            @if (
              form.get('howDidYouHearAboutJobDescription')?.invalid &&
              form.get('howDidYouHearAboutJobDescription')?.touched
            ) {
              <mat-error> Additional details are required. </mat-error>
            }
          </mat-form-field>
        </div>
      }
    </section>

    <footer class="footer-bar">
      @if (form.valid) {
        <div class="agreement-text">
          <span class="agreement-regular"> By clicking apply, you agree to share your profile information with </span>
          <span class="agreement-bold">{{ carrierData?.companyName }}.</span>
        </div>
      }

      <div class="button-container">
        <button type="submit" class="apply-button" [disabled]="form.invalid || isSubmitting">Apply</button>
      </div>
    </footer>
  </form>
</div>
